<template>
    <BreadCrumb PageTitle=" Ajouter une facture" />
    <AddFacture2/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddFacture2 from "@/components/Facture/AddFacture2.vue";
  
    export default defineComponent({
      name: "AddFacture2Page",
      components: {
        BreadCrumb,
        AddFacture2,
      },
    });
  </script>